import { Component, Input, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { AuthService } from 'app/service/auth/auth.service';
import { ToastrService } from 'ngx-toastr';
import { LoginService } from '../loginone/login.service';
import { UserLogin } from 'app/shared/models/user-login.model';
import { PageTitleService } from 'app/core/page-title/page-title.service';
import { ValidateService } from 'app/shared/validate.service';
import { GlobalService } from 'app/shared/global.service';
import { DatePipe } from '@angular/common';
import { MiscService } from 'app/shared/misc.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { BookingService } from './booking.service';
import { SetRights } from 'app/shared/set-rights';
import { PickDateAdapter, PICK_FORMATS } from "app/shared/format-datepicker";
import { DateAdapter, MAT_DATE_FORMATS } from "@angular/material/core";


@Component({
  selector: 'app-booking',
  templateUrl: './booking.component.html',
  styleUrls: ['./booking.component.scss'],
  providers: [
    { provide: DateAdapter, useClass: PickDateAdapter },
    { provide: MAT_DATE_FORMATS, useValue: PICK_FORMATS }
  ],
})
export class BookingComponent implements OnInit {

  filters: string = '';
  messages = {};
  public currentDate = new Date();
  datePipe = new DatePipe("en-US");
  Today = '';
  items: [];
  AdmissionDuration: number = 0;
  validations: string[] = [];
  View: boolean = false;
  isregister: boolean = false;
  //checkinDate: Date;
  checkOut = '';
  // startDate = '';
  hideRow = false;
  ngForm: FormGroup;
  emailPattern: string = "^[a-zA-Z0-9_.+-]+@[a-zA-Z0-9-]+.[a-zA-Z0-9-.]+$";
  isRegistration = false;
  // userLogin: UserLogin = new UserLogin();
  loginForm: any;
  isInProgress = false;
  page = 1;
  LoginOnlineUserRegistrationID = 0;
  GuestName = "";
  headers: string[] = [];
  selectedAliesName: string;
  selectedRate = 0;
  isMainScreen = false;
  hide = true;
  AdmissionDurationRange = [];
  minDuration = 0;

  // slideConfig = { slidesToShow: 3, slidesToScroll: 1, dots: true, infinite: false }; // Slick slider config

  slideConfig = {
    slidesToShow: 2,
    slidesToScroll: 2,
    dots: true,
    infinite: false,
    responsive: []
  };

  constructor(
    private pageTitleService: PageTitleService,
    private router: Router,
    private authService: AuthService,
    private formBuilder: FormBuilder,
    private loginService: LoginService,
    private toasterService: ToastrService,
    public translate: TranslateService,
    public validateService: ValidateService,
    private route: ActivatedRoute,
    public globals: GlobalService,
    private miscService: MiscService,
    public bookingService: BookingService,
    private modalService: NgbModal,
  ) { }

  AllRegulations = [];
  ProtocolRegulation = [];
  // Get All regulation from mstregulation
  GetAllRegulations() {
    this.bookingService.GetAllRegulations().subscribe((data) => {
      this.AllRegulations = data;
      this.ProtocolRegulation = this.AllRegulations.filter((x) => x['RegulationType'] == 'Protocol' && x['RegulationModule'] == 'Online Booking');
      // for (let i = 0; i < this.ProtocolRegulation.length; i++) {
      //   this.ProtocolRegulation[i]["RegulationDescriptionEnglish"] = this.ProtocolRegulation[i]["RegulationDescriptionEnglish"].replace(/(\r\n|\n|\r)/g, '<br>');
      //   console.log(this.ProtocolRegulation[i]["RegulationDescriptionEnglish"]);
      // }
    });
  }

  // isChecked: boolean = false;

  updateCarouselConfig() {
    const width = window.innerWidth;

    if (width <= 481) {
      this.slideConfig.slidesToShow = 1; // 1 slide on mobile
    } else if (width <= 769) {
      this.slideConfig.slidesToShow = 2; // 2 slides on tablets
    } else if (width <= 1025) {
      this.slideConfig.slidesToShow = 2; // 3 slides on small desktops
    } else {
      this.slideConfig.slidesToShow = 2; // 3 slides on large screens
    }
  }

  // isOnlineAdmission = false;
  // isDonation = false;
  // GetComponent(param) {
  //   this.globals.isOnlineAdmission = false;
  //   this.globals.isDonation = false;
  //   if (param == 'OnlineA') {
  //     this.globals.isOnlineAdmission = true;
  //   } else if (param == 'Donate') {
  //     this.globals.isDonation = true;
  //   }
  // }

  maxDate(): string {
    const threeMonthsLater = new Date();
    threeMonthsLater.setMonth(threeMonthsLater.getMonth() + 3);
    return this.datePipe.transform(threeMonthsLater, 'yyyy-MM-dd');
  }
  genders = [
    { value: 'MALE', description: 'MALE' },
    { value: 'FEMALE', description: 'FEMALE' },
    { value: 'TRANSGENDER', description: 'TRANSGENDER' }
  ];

  MobileNo = '';

  issignin = false;
  isAddbutton = false;

  GetsigninDetails(Type) {
    this.issignin = false;

    if (Type == 'signin') {
      // this.issignin = true;
    } else if (Type == 'Addbutton') {
      this.issignin = true;
    }
    else {
      this.issignin = false;
    }
  }

  SelectedButtonRow = [];
  GetSelectedRow(item) {
    this.SelectedButtonRow = item;
  }

  ClearBedFilter() {
    this.AdmissionDuration = this.minDuration;
    this.checkinDate = this.datePipe.transform(this.currentDate, 'yyyy-MM-dd');
    this.SelectedButtonRow = [];
  }

  // Log Out User
  LogOut() {
    this.authService.logOut();
    this.ngForm.value.UserName = "";
    this.ngForm.value.LoginPassword = "";
    this.ngForm.value.firstName = "";
    this.ngForm.value.middleName = "";
    this.ngForm.value.lastName = "";
    this.ngForm.value.mobileNo = "";
    this.ngForm.value.email = "";
    this.ngForm.value.Password = "";
    this.LoginOnlineUserRegistrationID = 0;
    this.globals.UserName = '';
    this.BookingHistory = [];
    this.globals.UserID = 0;
    this.SelectedClassID = 0;
    this.MobileNo = '';
    this.ngForm.reset();
    this.isMainScreen = true;
    this.isregister = false;
    this.isRegistration = false;
    this.isbooknow = false;
    this.issignin = false;
  }

  // Getting Refresh Token
  GetRefreshToken(): void {
    this.authService.getRefreshToken().subscribe((data) => {
      if (data != undefined && data != null) {
        this.authService.setToken(data);
      }
      else {
        this.authService.logOut();
      }
    });
  }

  rowBackgrounds: string[] = ['bg-primary', 'bg-warning', 'bg-success', 'bg-danger', 'bg-warning', 'bg-primary', 'bg-success', 'bg-warning', 'bg-danger', 'bg-success', 'bg-primary'];
  getRowBackground(index: number): string {
    return this.rowBackgrounds[index % this.rowBackgrounds.length];
  }
  isbooknow: boolean = false;
  SelectedRow = [];
  Selectedheader = [];
  SelectedAliesName = "";
  SelectedClassID = 0;
  isLoginAvaibility = false;
  BookingHistory = [];
  tableitem = [];
  checkinDate = '';
  checkoutDate = '';
  BookingCount = 0;
  errorMessage = '';
  Nobedforthisrange = false;
  // Check bed availability from check in date on duration with get class, rate and count of Bed
  CheckAvailability() {
    this.checkinDate = this.datePipe.transform(this.checkinDate, 'yyyy-MM-dd');
    this.isInProgress = true;
    //this.GetBookingCount(this.checkinDate);
    setTimeout(() => {
      this.bookingService.getDailyBedCount(this.checkinDate, this.AdmissionDuration).subscribe((data) => {
        if (data && data.length > 0) {
          // Check if the response contains an error message
          if (data[0].Status === 'Error' || this.BookingCount == -1) {
            this.errorMessage = 'The database server is currently unreachable.Please try again later.'; // Show error message
            this.tableitem = [];
            this.bedData = [];
            this.headers = [];
          } else {
            this.tableitem = data;
            this.bedData = [];
            this.errorMessage = '';
            this.headers = [];
            // Dynamically populate headers excluding "ClassID" and "BedCount"
            data.forEach((value) => {
              Object.keys(value).forEach((key) => {
                if (key !== 'ClassID' && key !== 'BedCount' && key !== 'ImgURL' && !this.headers.includes(key)) {
                  this.headers.push(key);
                }
              });
            });
            data.forEach((value) => {
              let result = this.noVacancyMessage(value);
              if (result == '') {
                if (value['Healing retreat'] == "DELUXE TWIN WITH AC" && this.checkinDate > '2026-08-14') {
                  value['Rate'] = '1800.00';
                }
                if (value['Healing retreat'] == "SUPER DELUXE TWIN WITH AC" && this.checkinDate > '2026-08-14') {
                  value['Rate'] = '2000.00';
                }
                this.bedData.push(value);

              } else if (result == 'Total number of booking for this date is full. please book from another date!') {
                this.errorMessage = 'Total number of booking for this date is full. please book from another date!';
                return;
              }
            });
            if (this.bedData.length == 0) {
              this.Nobedforthisrange = true;
              this.errorMessage = 'No bed available for this range of data. please book for another date!';
            }
          }
        } else {

          this.errorMessage = "No data available.";
        }
        this.isInProgress = false;
      }, (error) => {
        this.errorMessage = "Failed to fetch data. Please check your connection and try again.";
        this.isInProgress = false;
      });
      const checkoutDate = new Date(this.checkinDate);
      checkoutDate.setDate(checkoutDate.getDate() + this.AdmissionDuration);
      this.checkoutDate = this.datePipe.transform(checkoutDate, 'yyyy-MM-dd');
    }, 100);
  }

  GetBookingCount(checkinDate) {
    checkinDate = checkinDate == null ? this.checkinDate = this.datePipe.transform(this.checkinDate, 'yyyy-MM-dd') : checkinDate;

    this.bookingService.GetBookingCount(checkinDate).subscribe((data) => {
      this.BookingCount = data;
    });
  }

  getDateFromHeader(items): Date | null {
    const parts = items.split(',');
    if (parts.length >= 2) {
      const dateString = parts[1].trim();
      const [day, month, year] = dateString.split('-').map(part => parseInt(part, 10));
      // Construct the date object manually
      const date = new Date(year, month - 1, day); // Note: Subtract 1 from month
      return date;
    } else {
      console.error('Invalid header format:', items);
      return null;
    }
  }

  section: string = '';
  ngOnInit() {
    this.globals.LastVisitedComponent = this.router.url;
    this.route.url.subscribe(() => {
      this.route.firstChild?.data.subscribe(data => {
        if (data['section']) {
          this.section = data['section'];
          if (this.section == 'Checkavailability') {
            this.getDoctorHoliday();
            this.CheckAvailability();
          }
        }
      });
    });

    this.ngForm = this.formBuilder.group({
      UserName: ['', [Validators.required]],
      LoginPassword: ['', [Validators.required]],
      firstName: ['', [Validators.required]],
      middleName: [''],
      lastName: ['', [Validators.required]],
      mobileNo: ['', [Validators.required]],
      email: ['', [Validators.required, Validators.pattern(this.emailPattern)]],
      Password: ['', [Validators.required]],
      Type: [''],
    });
    // this.GetAllRegulations();
    this.GetAdmissionDurationRange();
    this.updateCarouselConfig();
    window.addEventListener('resize', () => this.updateCarouselConfig());
    this.isMainScreen = true;
    this.Today = this.datePipe.transform(this.currentDate, 'yyyy-MM-dd');
    this.checkinDate = this.datePipe.transform(this.currentDate, 'yyyy-MM-dd');
  }

  GetAdmissionDurationRange() {
    this.miscService.getMiscellaneous('AdmissionDuration').subscribe(data => {
      this.AdmissionDurationRange = (data as any[]).sort((a, b) => Number(a.ExtraDescription) - Number(b.ExtraDescription));
      this.minDuration = Math.min(
        ...this.AdmissionDurationRange.map(x => Number(x.Description))
      );
      this.AdmissionDuration = this.minDuration;
    });
  }

  getAvailability() {
    //this.GetBookingCount(this.checkinDate);
    this.isMainScreen = false;
    this.isRegistration = false;
    this.isregister = true;
    this.isbooknow = false;
    this.CheckAvailability()
  }
  isFinalPayment = false;
  MakePayment(pram) {
    if (pram == 'Payment') {
      this.isbooknow = false;
      this.isFinalPayment = true;
    } else {
      this.isbooknow = true;
      this.isFinalPayment = false;
    }
  }

  bedData: any[] = [];
  GetBack() {
    this.section = 'IsMain';
  }

  GetlowestNumber(item): number {
    let lowestValue: number | null = null;
    lowestValue = this.getLowestDateValue(item);
    return lowestValue;
  }

  getLowestDateValue(data: any): number {
    const datePattern = /^\w{3}, \d{2}-\d{2}-\d{4}$/;
    const dateValues = Object.entries(data)
      .filter(([key, _]) => datePattern.test(key))
      .map(([_, value]) => Number(value));
    return Math.min(...dateValues);
  }

  hasAnyAvailability(item: any): boolean {
    if (this.BookingCount >= 40) {
      return false;
    } else {
      // Filter out headers that are not day columns.
      const dayHeaders = this.headers.filter(
        key => key !== 'Healing retreat' && key !== 'Rate'
      );
      // Return true only if every day has an availability greater than 0.
      return dayHeaders.every(key => item[key] > 0);
    }
  }

  noVacancyMessage(item: any): string {
    if (this.BookingCount >= 40) {
      return `Total number of booking for this date is full. please book from another date!`;
    } else {
      // 1. Identify which headers are "days" (exclude 'Healing retreat' and 'Rate')
      const dayHeaders = this.headers.filter(
        (key) => key !== 'Healing retreat' && key !== 'Rate'
      );

      // 2. Count how many of those days are 0
      const totalDays = dayHeaders.length;
      const noVacancyCount = dayHeaders.filter((key) => item[key] <= 0).length;

      // 3. Build the message
      //    Example: "No vacancy on 4 out of 7 days."
      if (noVacancyCount === 0) {
        // If all days > 0
        return ``;
      } else if (noVacancyCount === totalDays) {
        // If all days are zero
        return `No vacancy on all ${totalDays} days.`;
      } else {
        // Mixed scenario
        return `No vacancy on ${noVacancyCount} out of ${totalDays} days.`;
      }
    }
  }

  disabledDates = [];
  getDoctorHoliday() {
    let a = this.Today;
    // ClientID, LocationID, CurrentDate, DoctorID
    const formatedDate = this.datePipe.transform(this.globals.CurrentDateTime, 'yyyy-MM-dd');
    this.bookingService.getDoctorHoliday(2, 2, formatedDate, 0).subscribe((res) => {
      this.disabledDates = res;
    });
  }

  // Function to disable Sundays
  disableSundays = (d: Date | null): boolean => {
    if (!d) return false;

    const date = new Date(d);
    const day = date.getDay();

    // Format selected date to 'yyyy-mm-dd' string
    const dateString = date.toISOString().split('T')[0];

    // Convert all holiday dates to 'yyyy-mm-dd' strings for accurate comparison
    const holidayDateStrings = this.disabledDates.map(item =>
      new Date(item.HolidayDate).toISOString().split('T')[0]
    );

    // If SelectedType is 'Bed', disable Sundays and holiday dates
    return day !== 0 && !holidayDateStrings.includes(dateString);
  };

  // ===========================================

  hasScrolledToEnd = false;

  onScroll(event: any) {
    const element = event.target;
    if (element.scrollHeight - element.scrollTop <= element.clientHeight + 10) {
      this.hasScrolledToEnd = true;
    }
  }

}
